import React, { FC, useEffect, useState, useCallback } from "react";
import { TaxonomyType } from "data/types";
import CardNuitResumeIntegre from "components/CardNuitResumeIntegre/CardNuitResumeIntegre";
import ItemsSlider from 'components/ItemsSlider';
import ModalLieuxResume from 'components/ModalLieuxResume';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from "react-dnd-html5-backend";
import { useNavigate } from "react-router-dom";
import { JourneeType, EventType, PecType } from "data/types";
import 'react-tooltip/dist/react-tooltip.css';
import { useTranslation } from 'react-i18next';

interface GroupVille {
  libelle1: string;
  typeTransport?: string | null;
  lat: string | null;
  longi: string | null;
  firstDay: string;
  firstDayId: number;
  image?: string;
  images: string[];
  imageItems: ResumeImageItem[];
  nights: EventType[];
}

interface ResumeImageItem {
  url: string;
  caption: string;
}

interface GroupNuits {
  pays: string;
  nom_pays: string;
  groupVilles: GroupVille[];
}

interface Flags {
  [key: string]: string | undefined;
}

export interface PlanificateurResumeIntegreProps {
  className?: string;
  itemClassName?: string;
  categories?: TaxonomyType[];
  categoryCardType?: "card3" | "card4" | "card5";
  itemPerRow?: 4 | 5;
  sliderStyle?: "style1" | "style2";
  uniqueClassName: string;
  voyageKey: string;
  emailPartage: string;
  codePartage: string;
  mode: string;
  eventCategoriesPage: JourneeType[];
  id_pays: string;
  libelles_pays: string;
  nbJours: number;
  visibilite: string;
  etatVoyage: number;
  nb_voyageurs: number;
  monnaie: string;
  symbole_monnaie: string,
  numDroit: number; 
  username: string;
}


const PlanificateurResumeIntegre: FC<PlanificateurResumeIntegreProps> = ({
  categoryCardType = "card3",
  voyageKey,
  emailPartage,
  codePartage,
  mode,
  eventCategoriesPage,
  id_pays,
  libelles_pays,
  nbJours,
  visibilite,
  etatVoyage,
  nb_voyageurs,
  monnaie,
  symbole_monnaie,
  numDroit,
  username
}) => {
  const { t } = useTranslation();
  
  const [eventCategories, setEventCategories] = useState<JourneeType[]>([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const [selectedEvent, setSelectedEvent] = useState<EventType | null>(null);
  const [selectedEventIndex, setSelectedEventIndex] = useState<number>(0);
  const [selectedJournee, setSelectedJournee] = useState<number | null>(null);
  const [listePec, setListePec] = useState<PecType[]>([]);

  const [isModalLieuxResumeOpen, setIsModalLieuxResumeOpen] = useState(false);

  const [typeEvenementForModal, setTypeEvenementForModal] = useState("");
  const [idEvenementForModal, setIdEvenementForModal] = useState<number>(0);
  const [idJourneeForModal, setIdJourneeForModal] = useState<number>(0);

  const [groupedNights, setGroupedNights] = useState<any[]>([]);
  const [flags, setFlags] = useState<Flags>({});
  const [lieuxVisites, setLieuxVisites] = useState<Array<string>>([]);
const getRestCountriesCode = (codePays: string) => {
  if (["ww", "xx", "yy", "zz", "WW", "XX", "YY", "ZZ"].includes(codePays)) {
    return "gb";
  }

  return codePays;
};

  let navigate=useNavigate();

  const handleElementChange = useCallback(
    (journeeId: number, eventId: number, typeEvenement: string, valeur: string, typeElement: string) => {
      setEventCategories((prevCategories) => {
        return prevCategories.map((day) => {
          if (day.id_journee === journeeId) {
            return {
              ...day,
              evenements: day.evenements.map((event) => {
                if (
                  (typeEvenement === 'lieu' && event.typeEv === 'L' && event.id === eventId) ||
                  (typeEvenement === 'trajet' && event.typeEv === 'T' && event.id === eventId) ||
                  (typeEvenement === 'nuit' && event.typeEv === 'N' && event.id === eventId)
                ) {
                  if (typeElement === 'libelle1') {
                    return { ...event, libelle1: valeur };
                  } else if (typeElement === 'libelle2') {
                    return { ...event, libelle2: valeur };
                  } else if (typeElement === 'prix') {
                    return { ...event, prix: valeur };
                  } else if (typeElement === 'paiement') {
                    return { ...event, paiement: valeur };
                  } else if (typeElement === 'acompte_hebergement') {
                    return { ...event, acompte_hebergement: valeur };
                  } else if (typeElement === 'date_paiement_hebergement') {
                    return { ...event, date_paiement_hebergement: valeur };
                  } else if (typeElement === 'debut') {
                    return { ...event, debut: valeur };
                  } else if (typeElement === 'fin') {
                    return { ...event, fin: valeur };
                  } else if (typeElement === 'compagnie') {
                    return { ...event, compagnie: valeur };
                  } else if (typeElement === 'ref') {
                    return { ...event, ref: valeur };
                  } else if (typeElement === 'distance') {
                    return { ...event, distance: valeur };
                  } else if (typeElement === 'duree') {
                    return { ...event, duree: valeur };
                  } else if (typeElement === 'invisible1') {
                    return { ...event, invisible1: valeur };
                  } else if (typeElement === 'invisible2') {
                    return { ...event, invisible2: valeur };
                  } else if (typeElement === 'type') {
                    return { ...event, type: valeur };
                  } else if (typeElement === 'moment') {
                    return { ...event, moment: valeur };
                  } else if (typeElement === 'rattachement') {
                    return { ...event, rattachement: valeur };
                  } else if (typeElement === 'image') {
                    return { ...event, image: valeur };
                  } else if (typeElement === 'lat') {
                    return { ...event, lat: valeur };
                  } else if (typeElement === 'longi') {
                    return { ...event, longi: valeur };
                  } else if (typeElement === 'lat2') {
                    return { ...event, lat2: valeur };
                  } else if (typeElement === 'longi2') {
                    return { ...event, longi2: valeur };
                  } else if (typeElement === 'place') {
                    return { ...event, place: valeur };
                  } else if (typeElement === 'latModif') {
                    return { ...event, latModif: valeur };
                  } else if (typeElement === 'longiModif') {
                    return { ...event, longiModif: valeur };
                  } else if (typeElement === 'lat2Modif') {
                    return { ...event, lat2Modif: valeur };
                  } else if (typeElement === 'longi2Modif') {
                    return { ...event, longi2Modif: valeur };
                  } else if (typeElement === 'document') {
                    return { ...event, document: valeur };
                  } else if (typeElement === 'lien') {
                    return { ...event, lien: valeur };
                  } else if (typeElement === 'bloc') {
                    return { ...event, bloc: valeur };
                  } else if (typeElement === 'pays') {
                    return { ...event, pays: valeur };
                  } else if (typeElement === 'nom_pays') {
                    return { ...event, nom_pays: valeur };
                  }
                }
                return event;
              }),
            };
          }
          return day;
        });
      });
    },
    [] // dependencies, update if needed
  );

  

  useEffect(() => {

    if (JSON.stringify(eventCategories) !== JSON.stringify(eventCategoriesPage)) {
      setEventCategories(eventCategoriesPage);
      setLoading(false); 
    }
  }, [eventCategoriesPage]);

  useEffect(() => {
    const groups: GroupNuits[] = [];
    let currentGroupPays: GroupNuits | null = null;
    let currentGroupVille: GroupVille | null = null;
    const getResumeImageItemsFromDay = (day: JourneeType): ResumeImageItem[] => {
      return day.evenements
        .filter(
          (event) =>
            (event.typeEv === "L" || event.typeEv === "N") &&
            event.image &&
            event.image !== ""
        )
        .map((event) => {
          const libelle1 = event.libelle1 || "";
          const libelle2 = event.libelle2 || "";

          if (event.typeEv === "N") {
            const nightLabel = [libelle1, libelle2].filter(Boolean).join(" - ");

            return {
              url: event.image as string,
              caption: `Nuit ${day.num_jour}${nightLabel ? ` · ${nightLabel}` : ""}`,
            };
          }

          return {
            url: event.image as string,
            caption: `Jour ${day.num_jour} · ${libelle1}`,
          };
        });
    };

    const addUniqueImageItems = (
      target: ResumeImageItem[],
      imageItems: ResumeImageItem[]
    ) => {
      imageItems.forEach((imageItem) => {
        if (!target.some((targetItem) => targetItem.url === imageItem.url)) {
          target.push(imageItem);
        }
      });
    };

    const getTransportTypeForNight = (
      day: JourneeType,
      night: EventType
    ): string | null => {
      const trajets = day.evenements.filter(
        (event) => event.typeEv === "T" && event.type
      );
      const overnightTrajet = [...trajets]
        .reverse()
        .find((event) => event.invisible2 === "O");

      if (overnightTrajet?.type) return overnightTrajet.type;

      const precedingTrajet = [...trajets]
        .reverse()
        .find((event) => event.ordre <= night.ordre);

      return precedingTrajet?.type || null;
    };

    eventCategories.forEach((day) => {
      day.evenements.forEach((evenement) => {

        if ((evenement.libelle1 === "Nuit en transport" || evenement.libelle1 === "Night in transport" || (evenement.nom_pays !== null && evenement.nom_pays !== ''))
          && evenement.typeEv === 'N') {

          const paysNom = evenement.nom_pays || ( 
            !currentGroupPays && (evenement.libelle1 === "Nuit en transport" || evenement.libelle1 === "Night in transport") ? t('trajet')
            : currentGroupPays && (evenement.libelle1 === "Nuit en transport" || evenement.libelle1 === "Night in transport") && currentGroupPays.nom_pays !== t('nuitsIncompletes') ? currentGroupPays.nom_pays 
            : currentGroupPays && (evenement.libelle1 === "Nuit en transport" || evenement.libelle1 === "Night in transport") && currentGroupPays.nom_pays === t('nuitsIncompletes') ? t('trajet')
            :  t('nuitsIncompletes')
          );

          const codePays = evenement.pays || "";

          if (!currentGroupPays || currentGroupPays.nom_pays !== paysNom) {
            currentGroupPays = {
              nom_pays: paysNom,
              pays: codePays,
              groupVilles: []
            };
            groups.push(currentGroupPays);
            currentGroupVille = null; // Reset the current city group
          }

          const villeNom = evenement.libelle1 || t('cliquezCompleter');
          const typeTransport =
            evenement.libelle1 === "Nuit en transport" ||
            evenement.libelle1 === "Night in transport"
              ? getTransportTypeForNight(day, evenement)
              : null;
          const resumeImageItems = getResumeImageItemsFromDay(day);
          const resumeImages = resumeImageItems.map((imageItem) => imageItem.url);

          if (!currentGroupVille || currentGroupVille.libelle1 !== villeNom) {
            currentGroupVille = {
              libelle1: villeNom,
              typeTransport,
              lat: evenement.lat,
              longi: evenement.longi,
              firstDay: day.date_journee.split(' ')[1],
              firstDayId: day.id_journee,
              image: resumeImages[0] || '',
              images: resumeImages,
              imageItems: resumeImageItems,
              nights: [evenement]
            };
            currentGroupPays.groupVilles.push(currentGroupVille);
          } else {
            currentGroupVille.nights.push(evenement);
            addUniqueImageItems(currentGroupVille.imageItems, resumeImageItems);
            currentGroupVille.images = currentGroupVille.imageItems.map(
              (imageItem) => imageItem.url
            );
          }

          if (!currentGroupVille.image && currentGroupVille.imageItems.length > 0) {
            currentGroupVille.image = currentGroupVille.imageItems[0].url;
          }
        }
      });
    });

    setGroupedNights(groups);
  }, [eventCategories]);
  
  useEffect(() => {
  groupedNights.forEach((group) => {
    const countryCode = group.pays;

    if (!countryCode) return;

    if (countryCode in flags) return;

    const flagCode = getRestCountriesCode(countryCode).toLowerCase();

    setFlags((prevFlags) => ({
      ...prevFlags,
      [countryCode]: `https://flagcdn.com/w40/${flagCode}.png`,
    }));
  });
}, [groupedNights, flags]);
    
  useEffect(() => {
    const updatedListePec = eventCategories.flatMap((day) =>
    day.evenements
      .filter(
        (event) =>
          event.location === 'O' &&
          event.moment === 'P'
      )
      .map((event) => ({
        date_journee: day.date_journee,
        id_journee: day.id_journee,
        id_evenement: event.id, 
        type_transport: event.type || "",
        rattachement: event.rattachement || "",
        debut: event.debut || ""
      }))
  );

  setListePec(updatedListePec);

  }, [eventCategories]);


  

  if (loading) {
    return <div className="text-center mt-20 mb-20"><h1 className="text-xl">{t('chargementVoyage')}</h1></div>;
  }

  const openModal = (idJournee: number, event: EventType, eventIndex: number) => {

    setSelectedEvent(event);
    setSelectedEventIndex(eventIndex);
    setSelectedJournee(idJournee);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedEvent(null);
    setSelectedEventIndex(0);
    setSelectedJournee(null);
    setIsModalOpen(false);
  };

  
 
  const openModalLieuxResume = () => {
    setIsModalLieuxResumeOpen(true);
  };

  const closeModalLieuxResume = () => {
    setIsModalLieuxResumeOpen(false);
  };

const handleLieuxResumeClick = async (nuits: EventType[]) => {

    try {

      var listeLieuxVisites: string[] = [];
      var listeLieuxVisitesTemp="";

      nuits.forEach((nuit) => {
        eventCategories.forEach((day) => {
          if(day.date_journee && day.date_journee !== '')
          {
            listeLieuxVisitesTemp=day.date_journee.split(' ')[1] + " :";
          }

          day.evenements.forEach((evenement) => {
            if(evenement.typeEv === "L" && (evenement.type === null || evenement.type === ""))
            {
              if(evenement.libelle1 !== null && evenement.libelle1 !== "")
              {
                listeLieuxVisitesTemp+=" "+evenement.libelle1 + " - ";
              }
            }
            if(evenement.typeEv === "N")
            {
              if(evenement.id === nuit.id)
              {

                  if(listeLieuxVisitesTemp.length === 12)
                  {
                    listeLieuxVisites.push(listeLieuxVisitesTemp + " " + t('aucunLieuRenseigne'));
                  }
                  else
                  {
                    listeLieuxVisites.push(listeLieuxVisitesTemp.substring(0, listeLieuxVisitesTemp.length-3));
                  }
                  listeLieuxVisitesTemp="";
              }
              else
              {
                listeLieuxVisitesTemp="";
              }
            }
            
          });
        });
      });

      setLieuxVisites(listeLieuxVisites);
    
      openModalLieuxResume();

    } catch (error: any) {
  
      if (error.response?.status === 401) {
        localStorage.removeItem('xsrfToken');
      }
      console.error("Error fetching data:", error);
      navigate('/');
    }
}

  return (
    <DndProvider backend={HTML5Backend}>

    { groupedNights.length === 0 
    ? (<div className="mt-4 mb-20 text-sm text-center sticky">Aucune ville localisée n'est présente pour les éléments nuits</div>)
    :
    (<ItemsSlider title="" nomClass="item-slider-container" classDay="day-item-integre" classSlider="item-slider-integre"> 
    {groupedNights.map((group: any, index: number) => (
        <div key={index} className="text-center">
         <div className="relative flex items-center justify-center mb-8 w-full">
  <div className="flex-1 border-t border-neutral-400" />

  <div className="relative flex items-center justify-center px-6">
    <h2
      className={`
        text-sm
        font-bold
        tracking-tight
        text-center
        whitespace-nowrap
        mr-2
        ${
          group.nom_pays === t("nuitsIncompletes")
            ? "couleurRose"
            : "text-neutral-900"
        }
      `}
    >
      {group.nom_pays}
    </h2>

    {flags[group.pays] &&
          flags[group.pays] !== "loading" && (
            <span className="ml-3 text-2xl leading-none">
              <img
                src={flags[group.pays] || ""}
                alt={group.nom_pays}
                className="h-4 w-6 rounded-sm object-cover"
              />
            </span>
          )}
  </div>

  <div className="flex-1 border-t border-neutral-400" />
</div>
         {group.groupVilles.map((ville: any, villeIndex: number) => {
          const isFirst =
            index === 0 &&
            villeIndex === 0;

          const isLast =
            index === groupedNights.length - 1 &&
            villeIndex === group.groupVilles.length - 1;

          return (
            <CardNuitResumeIntegre
              key={`${index}-${villeIndex}`}
              libelle={ville.libelle1}
              jour={ville.firstDay}
              nbNuits={ville.nights.length}
              image={ville.image}
              images={ville.images}
              imageItems={ville.imageItems}
              pays={group.pays}
              isModif={false}
              isFirst={isFirst}
              isLast={isLast}
              typeTransport={ville.typeTransport}
              onLieuxResumeClick={() => handleLieuxResumeClick(ville.nights)}
            />
          );
        })}
        </div>
      ))}


{isModalLieuxResumeOpen && (
       <ModalLieuxResume 
        onLieuxResumeCloseModal={closeModalLieuxResume} 
        lieux={lieuxVisites}
        />
       )}

  </ItemsSlider>
  )}
  </DndProvider>
  );
};

export default PlanificateurResumeIntegre;
